import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { PUBLIC_QUERY_STALE_TIME } from '../queryOptions.helpers';
import { systemPagesApi } from './system-pages.api';

export const querySystemPage = {
  idOrAlias: (idOrAlias: string) =>
    queryOptions({
      queryKey: [QueriesKeys.systemPage, idOrAlias],
      queryFn: () => systemPagesApi.getSystemPageByIdOrAlias(idOrAlias),
      staleTime: PUBLIC_QUERY_STALE_TIME,
      // select: data => data,
    }),
  list: () =>
    queryOptions({
      queryKey: [QueriesKeys.systemPages],
      queryFn: () => systemPagesApi.getListOfSystemPages(),
      staleTime: PUBLIC_QUERY_STALE_TIME,
    }),
};
